import React from 'react';
import { useTranslation } from 'react-i18next';
import { Building2, Route } from 'lucide-react';

export const RideModeToggle = ({ rideMode, setRideMode }) => {
  const { t } = useTranslation();

  return (
    <div className="ride-mode-toggle" data-testid="ride-mode-toggle">
      <label style={{ fontSize: '0.9rem', fontWeight: 600, color: '#374151', marginBottom: '0.5rem', display: 'block' }}>
        {t('rideMode.title')}
      </label>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
        <button
          type="button"
          data-testid="ride-mode-city"
          onClick={() => setRideMode('city')}
          style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.35rem',
            padding: '0.85rem 0.75rem', borderRadius: '12px', cursor: 'pointer',
            border: `2px solid ${rideMode === 'city' ? '#3b82f6' : '#e5e7eb'}`,
            background: rideMode === 'city' ? '#eff6ff' : '#fff',
            transition: 'all 0.2s',
          }}
        >
          <Building2 size={22} style={{ color: rideMode === 'city' ? '#2563eb' : '#9ca3af' }} />
          <span style={{ fontWeight: 600, fontSize: '0.85rem', color: rideMode === 'city' ? '#1d4ed8' : '#4b5563' }}>
            {t('rideMode.city')}
          </span>
          <span style={{ fontSize: '0.7rem', color: '#9ca3af' }}>{t('rideMode.cityDesc')}</span>
          <span style={{
            fontSize: '0.7rem', fontWeight: 700, padding: '0.15rem 0.5rem', borderRadius: '8px',
            background: rideMode === 'city' ? '#dbeafe' : '#f3f4f6',
            color: rideMode === 'city' ? '#1d4ed8' : '#6b7280'
          }}>
            {t('rideMode.shortRate')}
          </span>
        </button>

        <button
          type="button"
          data-testid="ride-mode-longdistance"
          onClick={() => setRideMode('longdistance')}
          style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.35rem',
            padding: '0.85rem 0.75rem', borderRadius: '12px', cursor: 'pointer',
            border: `2px solid ${rideMode === 'longdistance' ? '#f59e0b' : '#e5e7eb'}`,
            background: rideMode === 'longdistance' ? '#fffbeb' : '#fff',
            transition: 'all 0.2s',
          }}
        >
          <Route size={22} style={{ color: rideMode === 'longdistance' ? '#d97706' : '#9ca3af' }} />
          <span style={{ fontWeight: 600, fontSize: '0.85rem', color: rideMode === 'longdistance' ? '#92400e' : '#4b5563' }}>
            {t('rideMode.longdistance')}
          </span>
          <span style={{ fontSize: '0.7rem', color: '#9ca3af' }}>{t('rideMode.longdistanceDesc')}</span>
          <span style={{
            fontSize: '0.7rem', fontWeight: 700, padding: '0.15rem 0.5rem', borderRadius: '8px',
            background: rideMode === 'longdistance' ? '#fef3c7' : '#f3f4f6',
            color: rideMode === 'longdistance' ? '#92400e' : '#6b7280'
          }}>
            {t('rideMode.longRate')}
          </span>
        </button>
      </div>
    </div>
  );
};
